export default "__VITE_ASSET__DDjoZdMU__"